import type { OAuthProviderInputType, OAuthProviderType } from '~/types/OAuth'
import api from './api'

/** Gestión de proveedores OAuth (config global, solo root). */
export const oauthService = {
  async getProviders() {
    const { data } = await api.get('/oauth/providers')
    return data.data as { providers: OAuthProviderType[] }
  },

  async saveProviders(providers: OAuthProviderInputType[]) {
    const { data } = await api.put('/oauth/providers', { providers })
    return data.data as { providers: OAuthProviderType[] }
  }
}
